import React from "react";

const Blling = () => {
  return (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.3334 2.00004V12C17.3334 12.4584 17.1702 12.8507 16.8438 13.1771C16.5174 13.5035 16.1251 13.6667 15.6667 13.6667H2.33341C1.87508 13.6667 1.48272 13.5035 1.15633 13.1771C0.829942 12.8507 0.666748 12.4584 0.666748 12V2.00004C0.666748 1.54171 0.829942 1.14935 1.15633 0.822957C1.48272 0.496568 1.87508 0.333374 2.33341 0.333374H15.6667C16.1251 0.333374 16.5174 0.496568 16.8438 0.822957C17.1702 1.14935 17.3334 1.54171 17.3334 2.00004ZM2.33341 3.66671H15.6667V2.00004H2.33341V3.66671ZM2.33341 7.00004V12H15.6667V7.00004H2.33341Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Blling;
